import React from 'react';
import { useQuery } from 'react-query';

import { Divider, MainButton, ButtonsRow, Paragraph, TitleContainer, NormalPopup } from '@beacharound/beacharound-ui';
import { trackCall } from '@beacharound/beacharound-ui-helpers';

import { getBeachContacts } from '../../api/beach';

export default function BeachesPhonePopup({visible, setVisible, beach}) {

    const { data: contacts, status } = useQuery(["beaches", beach?.slug, 'contacts'], () =>
        getBeachContacts({slug: beach?.slug}),
        {
            enabled: !!visible && !!beach?.slug,
            onSuccess: () => trackCall({name: beach?.name, type: beach?.type, slug: beach?.slug})
        }
    )

    return (
        <NormalPopup
            visible={visible}
            setVisible={setVisible}
            title="Chiama e prenota"
        >
            <TitleContainer>
                <Paragraph text="Stai per chiamare questa spiaggia per prenotare il tuo posto. Beacharound ti augura una buona giornata al mare!"/>
            </TitleContainer>

            <Divider/>

            <ButtonsRow center>
                <MainButton
                    text="Chiama e prenota"
                    component="a"
                    status={status}
                    blank
                    to={`tel:${contacts?.phone}`}
                />
            </ButtonsRow>
        </NormalPopup>
    )
}